import type { PublicInputField } from './types';

export type InputValues = Record<string, unknown>;

const isEmpty = (value: unknown) => value === undefined || value === null || value === '';

export function sortFields(fields: PublicInputField[]): PublicInputField[] {
  return [...fields].sort((left, right) => left.order - right.order);
}

/** Server default, else the first option of a required enum, so required fields start filled. */
export function defaultValues(fields: PublicInputField[]): InputValues {
  const values: InputValues = {};
  for (const field of fields) {
    if (!isEmpty(field.default)) values[field.key] = field.default;
    else if (field.required && field.type === 'enum' && field.enum?.length) {
      values[field.key] = field.enum[0];
    }
  }
  return values;
}

/** Defaults for a new field list, keeping what the user already set for fields that still exist. */
export function mergeValues(fields: PublicInputField[], current: InputValues): InputValues {
  const next = defaultValues(fields);
  for (const field of fields) {
    if (!isEmpty(current[field.key])) next[field.key] = current[field.key];
  }
  return next;
}

export function missingRequired(fields: PublicInputField[], values: InputValues): string[] {
  return fields
    .filter((field) => field.required && isEmpty(values[field.key]))
    .map((field) => field.label);
}

export function cleanValues(fields: PublicInputField[], values: InputValues): InputValues {
  const cleaned: InputValues = {};
  for (const field of fields) {
    const value = values[field.key];
    if (!isEmpty(value)) cleaned[field.key] = value;
  }
  return cleaned;
}

export function hasPricingDimension(fields: PublicInputField[]): boolean {
  return fields.some((field) => field.pricingDimension);
}
